import { render, staticRenderFns } from "./GradeRuleCreateSubgrades.vue?vue&type=template&id=95ce8ca4"
import script from "./GradeRuleCreateSubgrades.vue?vue&type=script&lang=js"
export * from "./GradeRuleCreateSubgrades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports